export enum AdvanceSettings {
	SKIP_ANSWERED = 'SKIP_ANSWERED',
	CALL_UNCALLED_ONLY = 'CALL_UNCALLED_ONLY',
	FINISH_RUN_OUT_CREDITS = 'FINISH_RUN_OUT_CREDITS',
	AUTORUN_AFTER_COMPLETED = 'AUTORUN_AFTER_COMPLETED',
	AUTORUN_AFTER_COMPLETED_HOURS = 'AUTORUN_AFTER_COMPLETED_HOURS',
	FINISH_IF_NO_CREDITS = 'FINISH_IF_NO_CREDITS',
	FINISH_IF_NO_CREDITS_TIME = 'FINISH_IF_NO_CREDITS_TIME',
}
